<template>
    <tr>
        <td>{{ title }}</td>
        <td>
            <AppSwitch @toggleCheck="toggleActive"/>
        </td>
    </tr>
</template>

<script>
import AppSwitch from '../input/AppSwitch.vue'

export default {
  name: 'app-table-controls-elem',
  components: {
    AppSwitch
  },
  props: {
    title: String
  },
  data () {
    return {

    }
  },
  methods: {
    toggleActive () {
      this.$emit('toggleActive')
    }
  }
}
</script>

<style lang="scss" scoped>
    @import '../../../assets/css/system/_vars';
    @import '../../../assets/css/system/_mixins';

    @import './_table-controls';
</style>
